export const CSV_DOWNLOADED = "download.csvDownloaded";
export const FILE_DOWNLOADED = "download.fileDownloaded";
